import { Row, Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Notify from "../../components/common/Notify";
import TableDeal from "../../components/common/Table/TableDeal";
import { dealSelector, pupSelector } from "../../services/selector/index.";
import {
  deleteDeal,
  getDetailDeal,
  getGroupTime,
  resetState,
  resetStatus,
  setOpenDetailDeals,
  setOpenModalGetLogDeal,
} from "../../services/slice/DealSlice";
import { setOpenPUDelete } from "../../services/slice/PopUpSlice";
import "../../assets/style/pageStyle/postDeals.scss";
import TableArea from "../../components/common/Table/TableAreaOne";
import ModalShowDetail from "../../components/common/Modal/getDetail/ModalShowDetail";
import ModalDelete from "../../components/common/Modal/delete/ModalDelete";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import ModalPostDeals from "../../components/common/Modal/add/ModalPostDeals";
import ModalEditDeal from "../../components/common/Modal/edit/ModalEditDeal";

const PostDeals = () => {
  const dispatch = useDispatch();
  const dealState = useSelector(dealSelector);
  const pupState = useSelector(pupSelector);
  const { dataDelete } = pupState;
  const { t } = useTranslation();
  const [tab, setTab] = useState(3);

  useEffect(() => {
    return () => dispatch(resetState());
  }, [dispatch]);

  const handleDelete = () => {
    dispatch(deleteDeal(dataDelete.id));
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };
  const handleChangeTabs = (key) => {
    setTab(key);
  };

  const valueSelectTimeGroup = useMemo(() => {
    let result = [
      { value: -1, label: t("Tất cả") },
      { value: 0, label: t("Toàn bộ KH") },
      { value: 1, label: t("KH thuộc đại lý") },
      { value: 2, label: t("KH Online") },
      { value: 3, label: t("KH Không bản quyền") },
    ];

    return result;
  }, [dealState.dataGroupTime, t]);
  return (
    <div className="wrapperPostDeals containerContentPage">
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          handleDelete={handleDelete}
          width={600}
          content="Bạn có đồng ý xóa bài viết không?"
        />
      )}
      <Notify
        content={dealState.msg}
        isNotify={dealState.isNotify}
        title="Thông báo"
        type={dealState.typeNotify}
        reset={resetStatus}
      />
      {dealState.isOpenModalDetail && (
        <ModalShowDetail
          getData={() => getDetailDeal(dealState.idDeals)}
          selector={dealSelector}
          close={() => setOpenDetailDeals({ isOpen: false, id: "" })}
        />
      )}
      {dealState.isOpenModalGetLog && (
        <ModalGetLog
          open={dealState.isOpenModalGetLog}
          setOpen={setOpenModalGetLogDeal}
          data={dealState.dataLog}
        />
      )}
      {dealState.isOpenModalPostDeals && (
        <ModalPostDeals title={"Thêm mới bài viết ưu đãi"} />
      )}
      {dealState.isOpenModalEditDeal && (
        <ModalEditDeal title={"Chỉnh sửa bài viết ưu đãi"} />
      )}
      <div className="headerPage">
        <h2 className="title">{t("Ưu đãi")}</h2>
      </div>

      <Row className="tableContent">
        <Tabs
          key={1}
          activeKey={tab}
          onChange={handleChangeTabs}
          items={[
            {
              label: t("Tất cả"),
              key: 3,
              children: (
                <TableDeal valueSelectTimeGroup={valueSelectTimeGroup} />
              ),
            },
            {
              label: t("Vị trí nổi bật"),
              key: 1,
              children: <TableArea areaType={tab < 3 ? tab : null} />,
            },
            // {
            //   label: t("Vùng 2"),
            //   key: 2,
            //   children: <TableArea areaType={tab < 3 ? tab : null} />,
            // },
          ]}
        />
      </Row>
    </div>
  );
};

export default PostDeals;
